var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 57.4219C48.5025 57.4219 57.4219 48.5025 57.4219 37.5C57.4219 26.4975 48.5025 17.5781 37.5 17.5781C26.4975 17.5781 17.5781 26.4975 17.5781 37.5C17.5781 48.5025 26.4975 57.4219 37.5 57.4219Z",
    fill: "#EFCC00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 5.85938V12.8906",
    stroke: "#EFCC00",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1406 37.5H62.1094",
    stroke: "#EFCC00",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8906 37.5H5.85938",
    stroke: "#EFCC00",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8711 15.1289L54.9023 20.0977",
    stroke: "#EFCC00",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0977 20.0977L15.1289 15.1289",
    stroke: "#EFCC00",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.168 54.1992C43.3517 53.9527 39.6522 52.7843 36.3865 50.7943C33.1209 48.8043 30.3866 46.052 28.418 42.7734H18.3047C19.1327 45.7729 20.6518 48.5367 22.7403 50.8433C24.8288 53.15 27.4286 54.9353 30.3313 56.0563C33.234 57.1773 36.359 57.6028 39.4557 57.2986C42.5525 56.9944 45.5349 55.969 48.1641 54.3047C47.8242 54.2695 47.5078 54.2227 47.168 54.1992Z",
    fill: "#E0E0E0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8828 42.7734H16.207",
    stroke: "#B9C1C6",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83594 48.6328H22.5234",
    stroke: "#B9C1C6",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M5.68359 54.4922H63.1172",
    stroke: "#B9C1C6",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M40.418 60.3516H65.2148",
    stroke: "#A5A9AA",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.68359 60.3516H31.9922",
    stroke: "#B9C1C6",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9375 66.2109H53.6133",
    stroke: "#A5A9AA",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.78125 66.2109H23.5781",
    stroke: "#A5A9AA",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8398 48.6328H36.1992",
    stroke: "#B9C1C6",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMist);
export default __webpack_public_path__ + "static/media/mist.b2c7e668d052177332de9fb49bd6ac4a.svg";
export { ForwardRef as ReactComponent };